export const getDefaultState = () => {
  return {
    unauthorizedModal: false,
  };
};

const state = { ...getDefaultState() };

export default state;
